import { React } from 'react';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Alert, Box, Button, Skeleton, Typography, Link } from '@mui/material';
import styles from './style';

const EirMissingStep = ({
  action,
  ctaText,
  missingStepMessage,
  loading,
  setIncompleteCart,
  ariaLabel,
}) => {
  const theme = useTheme();
  setIncompleteCart(true);
  return !loading ? (
    <Box sx={styles(theme).missingStep}>
      <Stack sx={{ width: '100%' }} spacing={1}>
        <Alert
          severity='error'
          action={
            <Button
              variant='buttonMedium'
              sx={styles(theme).missingAlertAction}
              onClick={action}
              aria-label={ariaLabel}
            >
              {ctaText}
            </Button>
          }
          sx={styles(theme).missingAlert}
        >
          {missingStepMessage === 'false' ? (
            <Typography
              variant='body2'
              sx={{
                color: theme.palette.primary.textColor3,
              }}
            >
              I confirm that I’ve read the &nbsp;
              <Link
                href='https://www.eir.ie/opencms/export/sites/default/.content/pdf/terms/eirmobile/eir-Mobile-Insurance-Product-Information-Document.pdf'
                passHref
                target='_blank'
                rel='noopener'
              >
                <Box component='a' aria-label='Insurance Product Information Document'>
                  Insurance Product Information Document
                </Box>
              </Link>
              &nbsp; and &nbsp;
              <Link
                href='https://www.eir.ie/opencms/export/sites/default/.content/pdf/terms/eirmobile/eir-Mobile-Insurance-TCs.pdf'
                passHref
                target='_blank'
                rel='noopener'
              >
                <Box component='a' aria-label='Terms & Conditions'>
                  Terms & Conditions
                </Box>
              </Link>
            </Typography>
          ) : (
            missingStepMessage
          )}
        </Alert>
      </Stack>
    </Box>
  ) : (
    <Skeleton variant='rectangular' width='100%' height='100%' />
  );
};
export default EirMissingStep;
